import PropTypes from 'prop-types';
import React, { useContext, useState } from 'react';

const Context = React.createContext({});

// eslint-disable-next-line react/display-name
export const FormContextProvider = React.memo((props) => {
  const [disabled, setDisabled] = useState(props.disabled);

  return <Context.Provider value={{ disabled, setDisabled }}>{props.children}</Context.Provider>;
});

FormContextProvider.propTypes = {
  disabled: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

FormContextProvider.defaultProps = {
  disabled: false,
};

export const useFormContext = () => useContext(Context);
